<main>
  <mat-button-toggle-group>
    <mat-button-toggle routerLink="/">
      <mat-icon>
        home
      </mat-icon>
    </mat-button-toggle>
    <mat-button-toggle routerLink="editor">
      <mat-icon>
        edit
      </mat-icon>
    </mat-button-toggle>
    <mat-button-toggle routerLink="/panel/map-editor">
      <mat-icon>
        map
      </mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</main>
